import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './ArticleView.module.scss';
import formStyles from '../../common/ui/Form.module.scss';
import qs from 'query-string';
import useFetch from '../../common/hooks/useFetch';

import ReplyArea from '../reply_area/ReplyArea';
import { useSelector } from 'react-redux';
import Reply from '../reply/Reply';
import axios from 'axios';
import { useCallback } from 'react';

const ArticleView = (props) => {

  const location = useLocation();
  const params = qs.parse(location.search);
  const navigate = useNavigate();

  const urlContent = '/api/board/view' + location.search;
  const [content, reFetchContent] = useFetch(urlContent, 410, 100, true);

  const urlReplies = '/api/reply/list' + location.search;
  const [replies, reFetchReplies] = useFetch(urlReplies, 510, 1, true);

  const [isDelete, setDelete] = useState(false);

  const [reReplyIndex, setReReplyIndex] = useState(-1);
  const [editReplyIndex, setEditReplyIndex] = useState(-1);

  const [isLogin, profile] = useSelector((state) => [state.profileReducer.isLogin, state.profileReducer.profile]);

  // Init
  //////////////////////////////////
  const getPath = () => {
    let temp = props.title;
    if (params.boardId) {
      const board = props.categoriesDic[params.boardId];
      if (board.parentId) {
        temp += ` / ${props.categoriesDic[board.parentId].title}`;
      }
      temp += ` / ${board.title}`;
    }

    return temp;
  }

  const returnToMenu = () => {
    const _params = {
      ...params,
      command: 'list'
    };
    delete _params.articleId;

    if (_params.fromRoot){
      delete _params.boardId;
    }

    navigate(location.pathname + '?' + qs.stringify(_params));
  }

  const listReplies = useCallback(()=>{
    const arr = [];

    if (replies.data) {
      for (let i = 0; i < replies.data.replies.length; i++) {
        const reply = replies.data.replies[i];
        if (reply.isDeleted === 'Y') {
          if (parseInt(reply.childCount) <= 0){
            continue;
          }
        }

        if (editReplyIndex === reply.id){
          arr.push(
            <ReplyArea key={-1}
              canCancel={true}
              isEdit = {true}
              initialValue={reply.content}
              isLogin={isLogin}
              profile={profile}
              info={{ id: reply.id}}
              reFetchReplies={(callback) => { 
                reFetchReplies(()=>{
                  setEditReplyIndex(-1);
                  if (callback){
                    callback();
                  }
                }); 
              }}
              cancelReply={()=>{setEditReplyIndex(-1)}}
              style={{ marginTop: '20px', width:reply.parentId ? '94%' : '100%' }}
            />)
        }
        else{
        arr.push(
          <Reply key={i} info={{...reply, isChild: reply.parentId}} 
          reReply={()=>{setReReplyIndex(reply.id)}}
          editReply={()=>{setEditReplyIndex(reply.id)}}
          isMine={isLogin ? profile.id === parseInt(reply.writerId) : false}
          reFetch={()=>{reFetchReplies();}}/>
        );
        }

        if (reReplyIndex === reply.id) {
          arr.push(
            <ReplyArea key={-1}
              canCancel={true}
              isLogin={isLogin}
              profile={profile}
              info={{ rootId: reply.rootId, parentId: reply.id }}
              reFetchReplies={(callback) => { 
                reFetchReplies(()=>{
                  setReReplyIndex(-1);
                  if (callback){
                    callback();
                  }
                }); 
              }}
              cancelReply={()=>{setReReplyIndex(-1)}}
              style={{ marginTop: '20px', width:'94%' }}
            />)
        }
      }
    }
    return arr;
  }, [replies.data, reReplyIndex, editReplyIndex]);

  const deleteArticle = () => {
    if (isDelete){
      return;
    }

    if (window.confirm('게시글을 삭제하시겠습니까?')){
      setDelete(true);
      axios.get('/api/board/delete?' + qs.stringify(params))
      .then((res) => {
        if (res.data.code === 430){
          returnToMenu();
        }
      })
      .catch((err)=>{

      })
      .finally(()=>{
        setDelete(false);
      });
      
    }
  }

  const editArticle = () => {
    const _params = {...params};
    _params.command = 'edit';

    navigate(location.pathname +'?' + qs.stringify(_params));
  }

  // Render
  /////////////////////////////////
  if (content.isLoading) {
    return '';
  }

  if (content.error) {
    return (
      <div id={styles.wrapper_articleView}>
        <div id={styles.error}>
          오류가 발생하였습니다.
        </div>
      </div>
    );
  }

  return (
    <div id={styles.wrapper_articleView}>
      <div id={styles.header}>
        <p className={styles.title}>{content.data.article.title}</p>
        <p className={styles.path}>{getPath()}</p>
        <button className={formStyles.button} onClick={returnToMenu}><p>목록으로</p></button>
        <div className={styles.writer_info}>
          <div className={styles.img_profile} alt='img' />
          <p className={styles.writer_nickname}>{content.data.article.writerNickname}</p>
          <p className={styles.write_date}>{content.data.article.writeDate}</p>
          <p className={styles.view_count}>조회수 {content.data.article.viewCount}</p>
        </div>
        {(isLogin && profile.id === parseInt(content.data.article.writerId)) && 
        <div className={styles.nav}>
        <p onClick={editArticle}>수정</p>
        <p onClick={deleteArticle}>삭제</p>
      </div>
        }
      </div>
      <div id={styles.body}>
        <div className={styles.content}>
          {content.data.article.content}
        </div>
      </div>
      <div id={styles.footer}>
        <div className={styles.nav_top}>
          <div className={styles.item}>
            <p>댓글 {replies.data ? replies.data.replies.filter(x=>x.isDeleted==='N').length : 0}</p>
          </div>
          <div className={styles.item}>
            <p><span style={{color:'red'}}>♡ </span>좋아요 {0}</p>
          </div>
        </div>
        <div className={styles.container}>
        <p className={styles.footer_title}>댓글</p>
        {listReplies()}
        <ReplyArea
          isLogin={isLogin}
          profile={profile}
          info={{}}
          reFetchReplies={(callback) => { reFetchReplies(()=>{
            if (callback){
              callback();
            }
          }); }}
          style={{ marginTop: '20px' }}
        />
        </div>   
      </div>
    </div>
  )
}

export default ArticleView